import {sendEvent} from '@github-ui/hydro-analytics'
import type {IssueFieldType} from './issue-field'

const EVENT_NAMESPACE = 'issue_fields_usage'
const VERSION = '1.0.1'

export type IssueFieldsUsageEvent = {
  page: 'org#settings' | 'issue#show' | 'issue#new' | 'memex#show'
  action: 'create' | 'update' | 'delete'
  fieldId: string
  fieldType: IssueFieldType | 'unknown' // 'unknown' is used for fields that are not recognized
  status: 'success' | 'error' | 'cancelled'
  duration?: number

  singleSelectOptionsCount?: number
  multiSelectOptionsCount?: number
  changes?: Array<'name' | 'description' | 'options'>
  interactionDuration?: number
  errorDetails?: string
  orgId?: string
}

export function reportIssueFieldsUsage(event: IssueFieldsUsageEvent) {
  // change keys from camelCase to snake_case
  const formattedEvent: Record<string, string | number> = {}
  for (const [key, value] of Object.entries(event)) {
    if (value !== undefined) {
      // Only include defined values
      const snakeCaseKey = key.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
      if (Array.isArray(value)) {
        formattedEvent[snakeCaseKey] = value.join(',')
      } else {
        formattedEvent[snakeCaseKey] = value
      }
    }
  }

  sendEvent(EVENT_NAMESPACE, {
    ...formattedEvent,
    version: VERSION,
  })
}
